import { render, staticRenderFns } from "./TopWave.html?vue&type=template&id=19d72245&scoped=true&"
import script from "./TopWave.vue?vue&type=script&lang=js&"
export * from "./TopWave.vue?vue&type=script&lang=js&"
import style0 from "./TopWave.scss?vue&type=style&index=0&id=19d72245&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d72245",
  null
  
)

export default component.exports